// @flow
import React from "react"
import styled from "styled-components"
import { Motion, spring, presets } from "react-motion"
import theme from "../UI/Theme"
import cloud1 from "./cloud1.svg"
import cloud2 from "./cloud2.svg"
import cloud3 from "./cloud3.svg"

const clouds: Array<string> = [cloud1, cloud2, cloud3]

type Position = { x: number, y: number }
const positions: Array<Array<Position>> = [
  [{ x: -100, y: -50 }, { x: -200, y: 50 }],
  [{ x: 200, y: 0 }, { x: 300, y: -100 }],
  [{ x: -100, y: -200 }, { x: -200, y: -400 }]
]

const Cloud = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -110px;
    height: 220px;
    width: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Background = styled.div`
    background: linear-gradient( 180deg, ${props => props.theme.backgroundGradientDark}, ${props => props.theme.backgroundGradientLight});
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
`

Background.defaultProps = { theme }

const Mask = styled.div`
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

const Clouds = ({ children }: { children?: any }) => (
  <Background>
    <Mask>
      {clouds.map((cloud, i) => {
        const [start, end] = positions[i]
        const defaultStyle = {
          x: start.x,
          y: start.y,
          opacity: 0
        }
        const style = {
          x: spring(end.x, presets.wobbly),
          y: spring(end.y, presets.wobbly),
          opacity: spring(1, presets.noWobble)
        }
        return (
          <Motion key={`clouds${i}`} defaultStyle={defaultStyle} style={style}>
            {is => (
              <Cloud
                style={{
                  transform: `translate(${is.x}px, ${is.y}px)`,
                  opacity: is.opacity
                }}
              >
                <img src={cloud} alt="" />
              </Cloud>
            )}
          </Motion>
        )
      })}
    </Mask>
    {children}
  </Background>
)

export default Clouds



// WEBPACK FOOTER //
// ./src/Clouds/index.js